import { createAsyncThunk, isFulfilled ,isPending} from '@reduxjs/toolkit';
import { defaultValue } from 'app/shared/model/device-truck-implement.model';
import { IDeviceTruckImplementDTO } from 'app/shared/model/dto/device-truck-implement-dto.model';
import { createEntitySlice, EntityState, IQueryParams, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import axios from 'axios';

const initialState: EntityState<IDeviceTruckImplementDTO> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/device-truck-implements';

// Actions

export const getDevicesByTruckID  = createAsyncThunk(
  'deviceTruckImplementDTO/fetch_entity_list', async (truckID: string) => {
  const requestUrl = `${apiUrl}-by-truck-id/${truckID}`;
  return axios.get<IDeviceTruckImplementDTO[]>(requestUrl);
});


export const DeviceTruckImplementDTOSlice = createEntitySlice({
  name: 'deviceTruckImplementDTO',
  initialState,
  extraReducers(builder) {
    builder
    
    .addMatcher(isFulfilled(getDevicesByTruckID), (state, action) => {
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    })
    
    .addMatcher(isPending(getDevicesByTruckID), state => {
      state.errorMessage = null;
      state.updateSuccess = false;
      state.loading = true;
    })
    

  },
});

export const { reset } = DeviceTruckImplementDTOSlice.actions;

// Reducer
export default DeviceTruckImplementDTOSlice.reducer;
